export type StaticRole = {
  name: 'Admin' | 'Member' | 'Guest',
  icon: string,
  summary: string,
  capabilities: string[],
}

// The roles are fixed. Their names must match the role names the backend expects in /api/v1/members/.
export const STATIC_ROLES: StaticRole[] = [
  {
    name: 'Admin',
    icon: 'fa-user-shield',
    summary: 'Full control over this brand account.',
    capabilities: [
      'Change brand settings',
      'Invite and remove users',
      'Manage outputs',
      'Manage connections',
    ],
  },
  {
    name: 'Member',
    icon: 'fa-user',
    summary: 'Works with outputs day to day.',
    capabilities: [
      'Use outputs',
    ],
  },
  {
    name: 'Guest',
    icon: 'fa-eye',
    summary: 'View-only access for observers.',
    capabilities: [
      'Read only everywhere',
    ],
  },
];

export const DEFAULT_ROLE: StaticRole['name'] = 'Member';

export const ADMIN_ROLE: StaticRole['name'] = 'Admin';

export function getStaticRole(name: string | null | undefined): StaticRole | null {
  return STATIC_ROLES.find(role => role.name === name) || null;
}
